import { __decorate } from "tslib";
import { customElement } from 'lit-element';
import { ProgressBarBase } from './vaadin-progress-bar-base';
import { ProgressMixin } from './vaadin-progress-mixin';
/**
 * `<vaadin-progress-bar>` is a Web Component for progress bars.
 *
 * @csspart part="bar" - Progress-bar's background
 * @csspart part="value" - Progress-bar's foreground
 */
let VaadinProgressBar = class VaadinProgressBar extends ProgressMixin(ProgressBarBase) {
    static get version() {
        return '2.0.0-alpha1';
    }
};
VaadinProgressBar.is = 'vaadin-progress-bar';
VaadinProgressBar = __decorate([
    customElement('vaadin-progress-bar')
], VaadinProgressBar);
export { VaadinProgressBar };
//# sourceMappingURL=vaadin-progress-bar.js.map